module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-弹窗关闭.0d75e.png";